import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {BadgeColorsEnum} from '../../../../shared/interfaces/BadgeColorsEnum';
import {ActivityTypesEnum} from '../../../../shared/interfaces/ActivityTypesEnum';
import {getDateFromISO} from '../../../../shared/helpers/helpers';
import {IInventory} from '../../../../shared/interfaces/inventory.interface';
import {Select, Store} from '@ngxs/store';
import {
  SetArchivedInventoryList,
  SetCurrentInventory,
  UnArchiveNDC
} from '../../../../shared/states/inventory/inventory.actions';
import {BaseTableDirective} from '../../../../shared/directives/base-table.directive';
import {take, withLatestFrom} from 'rxjs/operators';
import {Observable} from 'rxjs/internal/Observable';
import {TransactionsState} from '../../../../shared/states/transactions/transactions.state';

@Component({
  selector: 'app-inventory-archived-table',
  templateUrl: './inventory-archived-table.component.html',
  styleUrls: ['./inventory-archived-table.component.scss', './../inventory-table/inventory-table.component.scss'],
})
export class InventoryArchivedTableComponent extends BaseTableDirective {
  @Input() inventoryList: IInventory[];

  @Output() ndcUnArchived: EventEmitter<any> = new EventEmitter();

  tableColumns = {
    friendlyName: true,
    onHand: true,
    ['lastActivity.createDate']: false,
  };

  currentInventory: IInventory;
  showUnArchiveNDCDialog: boolean;

  BadgeColorsEnum = BadgeColorsEnum;
  ActivityTypesEnum = ActivityTypesEnum;

  getDateFromISO = getDateFromISO;

  @Select(TransactionsState.archivingStatus) archivingStatus$: Observable<boolean>;

  constructor(
    private router: Router,
    protected store: Store,
  ) {
    super(store);
  }

  openSingleRecordTable(inventory: IInventory): void {
    this.store.dispatch(new SetCurrentInventory(inventory));
    this.router.navigate(['inventory', inventory.drugID]);
  }

  openUnArchiveDialog(inventory: IInventory): void {
    this.currentInventory = inventory;
    this.showUnArchiveNDCDialog = true;
  }

  sortByColumn(columnName: string): void {
    this.store.dispatch(new SetArchivedInventoryList(this.sort(this.inventoryList, columnName)));
  }

  closeUnArchiveNDCDialog(): void {
    this.showUnArchiveNDCDialog = false;
  }

  unArchiveNDC(): void {
    this.store.dispatch(new UnArchiveNDC(this.currentInventory))
      .pipe(take(1), withLatestFrom(this.archivingStatus$))
      .subscribe(([_, status]) => {
        this.closeUnArchiveNDCDialog();
        this.ndcUnArchived.emit({success: status, inventory: this.currentInventory});
      });
  }
}
